const widgetSizeMax = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="m8 2 3.54 3.677H8.842V10.2h2.698L8 13.877 4.46 10.2H7.2V5.677H4.46z"/></svg>',
};

export { widgetSizeMax as default };
